module.exports = __webpack_public_path__ + "static/media/styledDatepicker-Chevrom-Left.24231008.svg";